import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=365a6792"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365a6792')) {
      api.createRecord('365a6792', component.options)
    } else {
      api.reload('365a6792', component.options)
    }
    module.hot.accept("./OrderHistory.vue?vue&type=template&id=365a6792", function () {
      api.rerender('365a6792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/driver/components/OrderHistory.vue"
export default component.exports